import React from 'react';
import RichTextComponents from './RichTextComponents';
// import { useIntl } from 'react-intl';
// import { assetsMapper } from '@kontent-ai/management-sdk';

const EducationalObjective: React.FC<{ element: any }> = ({ element }) => {
  //   const { formatMessage } = useIntl();

  if (!element.value || element.value === '<p><br></p>') {
    return null;
  }

  return (
    <div className="objective">
      <div className="objective-content">
        <p className="eotitle">{element.name}</p>
        <RichTextComponents element={element} />
      </div>
    </div>
  );
};

export default EducationalObjective;
